module.exports = __webpack_public_path__ + "assets/lightbox.676bf476.svg";